export const APPLICATION = {
  APP_NAME: 'Merchant Center',
};

export const BASE_PRICE_WHITELIST = ['V005', 'V007'];
